import React from 'react';

import { InputField } from 'vindi-ds-components';

function CustomerComplementField() {
  return (
    <InputField
      placeholder='Apartamento, bloco, etc'
      label='Complemento'
      name='complement'
    />
  );
}

export default CustomerComplementField;
